import { useStores } from '../stores/store';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import HashLoader from 'react-spinners/HashLoader';

function StartupPage(props) {
	const { auth } = useStores();
	// eslint-disable-next-line
	const [searchParams, setSearchParams] = useSearchParams();
	let navigate = useNavigate();

	useEffect(() => {
		auth.setKey(searchParams.get("key"));
		navigate('/login');
	}, [])

	return <div className='grid h-screen place-items-center'><HashLoader color="#EF7d00" /></div>
}

export default StartupPage;